import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { EMPTY_LIST } from '../../SnapdocsClosingSection.constants';
import { snapdocsListStyles } from '../../SnapdocsClosingSection.styles';
import { SnapdocsClosingSectionTestIds } from '../../SnapdocsClosingSection.testIds';
import { getDisplayValue } from '../../SnapdocsClosingSection.utils';
import SnapdocsClosingBlock from '../SnapdocsClosingBlock';

import { commentItemStyles, commentTextStyles } from './SnapdocsCommentsBlock.styles';

const SnapdocsCommentsBlock = ({ comments = EMPTY_LIST, commentCount, errorMessage }) => (
  <SnapdocsClosingBlock
    dataTestId={SnapdocsClosingSectionTestIds.COMMENTS_BLOCK}
    emptyMessage="No comments"
    errorMessage={errorMessage}
    isEmpty={!comments.length}
    title={`Comments (${_.isNil(commentCount) ? comments.length : commentCount})`}
  >
    <Box component="ul" sx={snapdocsListStyles}>
      {comments.map(({ commentUuid, author, text }) => (
        <Box component="li" key={commentUuid} sx={commentItemStyles}>
          <Typography variant="medium14">{getDisplayValue(author)}</Typography>
          <Typography color="text.secondary" sx={commentTextStyles} variant="regular14">
            {getDisplayValue(text)}
          </Typography>
        </Box>
      ))}
    </Box>
  </SnapdocsClosingBlock>
);

SnapdocsCommentsBlock.propTypes = {
  commentCount: PropTypes.number,
  comments: PropTypes.arrayOf(
    PropTypes.shape({
      commentUuid: PropTypes.string,
      author: PropTypes.string,
      text: PropTypes.string,
    }),
  ),
  errorMessage: PropTypes.string,
};

export default memo(SnapdocsCommentsBlock);
